export default __webpack_public_path__ + "static/media/PersonswithDisabilities_en.09066f7c.svg";